<template>
    <div id="main-content" v-if="device">
        <div class="top-block">
            <div class="selected-item">
                <div>
                    <span class="title">{{device.title || device.serial}}</span>
                    <span class="outdoor"> / за окном +18°</span>
                </div>
                <user-info></user-info>
            </div>

            <div class="tabs">
                <div class="tab" @click="tab='ctrl'" :class="{'active': tab === 'ctrl'}">Пульт</div>
            </div>
        </div>
        <div class="tab-content" v-if="tab === 'ctrl'">
            <device-control></device-control>
        </div>
        <div v-else class="tab-content">
            <p class="wf400" style="text-align: center; margin: 60px 0 0; color: #adadad">Раздел в разработке</p>
        </div>

    </div>
</template>

<script>
    import deviceControl from './device/ctrl'
    import userInfo from './other/topUserInfo'

    // пока не используются, но пригодятся позже
    const tabs = {
        'ctrl': 'Управление',
        'schedule': 'Расписание',
        'events': 'События',
        'energo': 'Энергопотребление',
    }
    export default {
        components:{
          deviceControl,
          userInfo,
        },
        data() {
            return {
                tab: 'ctrl',
                tabs,
            }
        },
        computed: {
            devId() {
                return this.$route.params.devId;
            },
            device() {
                return this.$store.state.devs.all[this.devId];
            },
        },
    }
</script>
